import DealerEditForm from "./dealer-edit-form";

export default DealerEditForm;